import { Schema } from '@core/data/dto/schema';

export const EmployeeIssueSchema = {
    code: Schema.String,
    reason: Schema.String,
    reason_description: Schema.String,
    type: Schema.Auto
}
